import { FormattedMessage } from 'react-intl';
import UnableToUpgradeDialogBase from './UnableToUpgradeDialogBase';

type Props = {
  onCloseRequest: () => void;
};

export default function UnableToUpgradeDialog({ onCloseRequest }: Props) {
  return <UnableToUpgradeDialogBase onCloseRequest={onCloseRequest} text={<FormattedMessage defaultMessage="Maybe later" />} />;
}
